<template>
  <b-modal
    id="modal-associate-case"
    ref="bModal"
    :title="$t('grid.detail.associatedCases')"
    :lazy="true"
    modal-class="associateCaseModal"
    centered
    @show="onShow"
  >
    <b-row
      v-if="patient"
      class="mx-0 mb-1"
    >
      <b-col class="pl-0 pr-0 px-5 mt-2">
        <div class="gr-card">
          <b-row class="px-3">
            <b-col class="p-0">
              <b-row class="pt-2 pl-2 pr-2 pb-1">
                <b-col>
                  <div class="d-flex align-items-center justify-content-center pb-1">
                    <i
                      class="fal fa-user-circle mr-2 main"
                      style="cursor:pointer"
                      aria-hidden="true"
                    />
                    <span>{{ patient.fullName }}</span>
                  </div>
                  <hr class="m-0">
                </b-col>
              </b-row>
              <b-row class="pb-1 pl-2 pr-2 gr-card-info">
                <b-col
                  v-if="globalParameters.mainPatientIdentifierType"
                  class="info text-center"
                >
                  <div><small>{{ globalParameters.mainPatientIdentifierType.name }}</small></div>
                  <div><span style="font-size:.9rem;color:#303133">{{ patient.mainPatientIdentifier && patient.mainPatientIdentifier.paiIdentifier }}</span></div>
                </b-col>
                <b-col
                  v-if="globalParameters.secondaryPatientIdentifierType"
                  class="info text-center"
                >
                  <div><small>{{ globalParameters.secondaryPatientIdentifierType.name }}</small></div>
                  <div><span style="font-size:.9rem;color:#303133">{{ patient.secondaryPatientIdentifier && patient.secondaryPatientIdentifier.paiIdentifier }}</span></div>
                </b-col>
                <b-col class="info text-center">
                  <div><small>{{ $t('entities.patient.gender') }}</small></div>
                  <div><span style="font-size:.9rem;color:#303133">{{ patient.gender && patient.gender.name }}</span></div>
                </b-col>
                <b-col class="info text-center">
                  <div><small>{{ $t('entities.patient.birthdate') }}</small></div>
                  <div><span style="font-size:.9rem;color:#303133">{{ patient.birthdate | date }}</span></div>
                </b-col>
                <b-col class="info text-center">
                  <div><small>{{ $t('global.age') }}</small></div>
                  <div><span style="font-size:.9rem;color:#303133">{{ patientTimeOld }}</span></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="pl-5 pr-5 my-3">
      <b-col>
        <b-row>
          <b-col>
            <div class="column">
              <div class="title text-center">
                {{ $t('component.AssociateCaseModal.associatedCases') }} a {{ caseNumber }}
              </div>
              <div class="filter p-1">
                <vt-input
                  v-model="associatedInput"
                  class="form-control form-control-sm"
                  type="text"
                  :placeholder="$t('component.protocolsModal.filter')"
                />
              </div>
              <div class="content">
                <div class="content">
                  <ul>
                    <li
                      v-for="(associatedCase, index) in filteredAssociatedCases"
                      :key="index"
                      class="pl-3"
                    >
                      {{ associatedCase.casenumber }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <b-row>
        <b-col
          class="d-flex justify-content-end"
          cols="12"
        >
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="hide"
          >
            {{ $t('global.close') }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>

import commonPatientServices from '@/api/resources/common/commonPatientServices'

export default {
    name: 'ModalAssociatedCasesReadOnly',
    props: {
        associatedCases: { type: Array },
        patientId: { type: Number },
        caseNumber: { type: String }
    },
    data() {
        return {
            associatedInput: '',
            patient: null
        }
    },
    computed: {
        laboratoryId() {
            return this.$store.getters.labId
        },
        patientTimeOld() {
            if (this.patient) return this.getPatientTimeOld(this.patient.birthdate)
            return ''
        },
        filteredAssociatedCases() {
            if (this.associatedCases.length) {
                return this.associatedCases.filter(associatedCase => associatedCase.casenumber.toUpperCase().includes(this.associatedInput.toUpperCase()))
            } else {
                return []
            }
        }
    },
    methods: {
        hide() {
            this.$refs.bModal.hide()
        },
        show() {
            this.$refs.bModal.show()
        },
        async onShow() {
            this.associatedInput = ''
            this.updateLoading(true)
            const [err, response] = await this.toCall(commonPatientServices.getPatientInformation(this.laboratoryId, this.patientId))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            this.patient = response
        }
    }
}

</script>

<style lang="scss">

    .associateCaseModal .modal-dialog{
        max-width: 60%;
    }

    .form-check-input{
      position: relative;
      top:2px;
    }

    .sample-item{
      padding: 0 !important;
    }

    .sample-item li a{
      margin-left: 5rem;
    }

    .sample-item li a:hover{
      color: grey !important;
    }

    .sample-item li{
      transition: .3s;
    }

    .sample-item li:hover{
      background: vt-color(light-primary);
    }

    .associateCaseModal .modal-body{
        padding: 0 !important;
    }

    </style>

<style lang="scss" scoped>
    h4{
      font-weight: normal;
      font-size: 1rem;
    }

    .modal-subheader{
      border-bottom: 1px solid vt-color(light-primary);
      padding: 1% 5%;
    }

    .vertical-line{
      width:1px;
      height: 30%;
      background:#dee2e6;
      display: inline-block;
    }

    .collapse-sample{
      border: 0;
      border-radius: 0;
      border-bottom:1px solid #dee2e6;
      margin-bottom: 0 !important;
    }

    .collapse-sample .card-header{
      transition: .3s;
      border: 0;
      background:none;
    }

    .collapse-sample .card-header:hover{
      background: vt-color(light-primary);
    }

    .collapse-sample span{
      position: relative;
      float: left;
      font-size: 0.9rem;
      color: #707070;
    }

    .collapse-sample i{
      position: relative;
      float: right;
      font-size: 1.2rem;
    }

    .collapse-sample .title{
      width: 70%;
    }

    .collapse-sample ul li{
      padding-top: 5px;
      list-style: none !important;
      font-size: 0.9rem;

    }

    .collapse-sample ul{
      padding-left: 1rem !important;
      margin-bottom: 0.5rem !important;
    }

    .line::before{
      content:"";
      position: absolute;
      width: 1px;
      height: 100px;
      background: #dadada;
      left: -10%;
      top: 43%;
    }

    .buttons i{
      font-size: 1.3rem;
    }

    .column{
       border: 1px solid rgba(0, 0, 0, 0.2) !important;
      -webkit-box-shadow: 1px 1px 5px 0px rgba(125,125,125,0.64);
      -moz-box-shadow: 1px 1px 5px 0px rgba(125,125,125,0.64);
      box-shadow: 1px 1px 5px 0px rgba(125,125,125,0.64);
    }

    .column .title{
      background-color: #e9ecef;
      color: #495057;
      border-color: #dee2e6;
      padding: 2% 10% !important;
      font-size: 0.9rem;
      font-weight: bold;
    }

    .column .content{
      height: 30vh;
      overflow: hidden;
      overflow-y: scroll;
      overflow-y: auto;
    }

    .content ul li{
      list-style: none;
    }

    .table .blocks{
      width: 50% !important;
    }

    .table{
      border: 1px solid rgba(0, 0, 0, 0.2) !important;
      -webkit-box-shadow: 1px 1px 5px 0px rgba(125,125,125,0.64);
      -moz-box-shadow: 1px 1px 5px 0px rgba(125,125,125,0.64);
      box-shadow: 1px 1px 5px 0px rgba(125,125,125,0.64);
      max-height: 30px !important;
      overflow: hidden;
      position: relative;
      color: #707070;
    }

    .filter{
      border-bottom: 1px solid #dee2e6;
    }

    .content ul li{
      list-style: none !important;
      transition: .3s;
      padding: 2%;
      font-size: 0.9rem;
    }

    .content ul li:hover{
      background: vt-color(light-primary);
    }

    .content ul{
      padding-left: 0;
      margin-bottom: 0.5rem !important;
    }

    .table td,
    .table th{
      padding-left: 10% !important;
      padding-right: 10% !important;
      border-top: none !important;
    }

    .table td input{
      height: calc(1.5em + 0.5rem + -5px) !important;
    }

    .table-hover tbody tr:hover{
      background-color: vt-color(light-primary) !important;
    }

    .table-hover tbody tr{
      transition: .3s;
    }

    @media (max-width: 1300px){

    .table{
      font-size: 0.9rem;
    }

    .sample-item li a{
      margin-left: 4rem;
    }

    }

</style>
